import { render, staticRenderFns } from "./hotMan.vue?vue&type=template&id=a1abd0a4&scoped=true&"
import script from "./hotMan.vue?vue&type=script&lang=js&"
export * from "./hotMan.vue?vue&type=script&lang=js&"
import style0 from "./hotMan.vue?vue&type=style&index=0&id=a1abd0a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1abd0a4",
  null
  
)

export default component.exports